import { marqueeItems } from "@/mocks/gossip";

const colorMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function MarqueeBar() {
  const row = [...marqueeItems, ...marqueeItems];
  return (
    <div className="relative overflow-hidden border-y border-background-200 bg-background-100 py-3">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-background-100 to-transparent"></div>
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-background-100 to-transparent"></div>
      <div className="flex w-max animate-marquee-left items-center gap-3">
        {row.map((item, i) => (
          <span
            key={`${item.id}-${i}`}
            className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium ${colorMap[item.color]}`}
          >
            <i className="ri-chat-quote-line text-xs"></i>
            {item.text}
          </span>
        ))}
      </div>
    </div>
  );
}